import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfflineMessageComponent } from './components/offline-message/offline-message.component';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OfflineMessageComponent
    ],
    declarations: [OfflineMessageComponent]
})
export class SharedModule
{
}
